var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.busy === false)?_c('v-container',{staticClass:"frame-container",attrs:{"fluid":""}},[(_vm.canUseMetabase && _vm.url && _vm.frame)?_c('iframe',{attrs:{"src":_vm.url,"width":"100%","height":"100%"}}):_c('v-alert',{attrs:{"type":"error"}},[_vm._v("\n    You do not have access to the reports and dashboards.\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }